import { ChangeDetectorRef, Component, OnInit, ɵ_sanitizeHtml } from '@angular/core';
import { DataServiceService } from 'src/app/services/data-service.service';
import { SeoService } from 'src/app/services/seo.service';
import { DomSanitizer, Meta } from '@angular/platform-browser';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { Data2Service } from 'src/app/services/data2.service';
import { SearchResult } from 'src/app/models/searchResult';
import { CommonModule } from '@angular/common';

import { ArticleCardComponent } from '../_components/article-card/article-card.component';
import { PaginatorComponent } from '../../_components/paginator/paginator.component';
import { ArticleSearchComponent } from '../_components/article-search/article-search.component';
import { ArticleSearchCardComponent } from '../_components/article-search-card/article-search-card.component';
import { LoadingComponent } from '../../_components/loading/loading.component';

@Component({
    selector: 'app-article-list',
    templateUrl: './article-list.component.html',
    styleUrls: ['./article-list.component.scss'],
    providers: [DataServiceService],
        imports: [RouterModule,CommonModule,ArticleCardComponent,PaginatorComponent,ArticleSearchComponent,ArticleSearchCardComponent,LoadingComponent]
})
export class ArticleListComponent implements OnInit {

  view="list";
  searchResults:SearchResult[] = [];
  title = "Investing for Catholics latest news and articles.";

  articleHeadline
  articles
  faEnvelope = faEnvelope;
  items = [];
  pageOfItems: Array<any>;
 loading=true;
  constructor(
    private dataservice: DataServiceService, 
    private data2service:Data2Service,
    private seoservice: SeoService, 
    private meta: Meta, 
    private DomSanitizer:DomSanitizer,
    private cdr: ChangeDetectorRef,
    private route:ActivatedRoute) { 
    
    route.queryParamMap.subscribe(resp=>{
      //console.log("route.queryParamMap>",resp,resp.get("q"))
      var q = resp.get("q");
      if(q && q.length>3 && q.length<50){
        this.search(q);        
      }
      else{
        this.view='list';
      }
    })


    this.dataservice.getArticle().subscribe(resp => {
      resp = resp.map( x => { 
        x.posterUrl = x.posterUrl?x.posterUrl.replace('http://', 'https://').replace("177x100", "512x288"):"https://services.ifa.com/art/images/1640_512x288_c_ifc-generic-article-banner.png"; 
      //  x.teaser = DomSanitizer.bypassSecurityTrustHtml(x.teaser);
        return x; 
    }); //fallback to logo image for articles
    //console.log("article-list.component.ts - resp:",resp)
     
     this.articleHeadline = resp[0];
     //removes first article from header
     this.articles = resp;
     this.articles.shift();

     this.items = Array(this.articles).fill(0).map((x, i) => ({ id: (i + 1), name: `Item ${i + 1}`}));
     this.loading=false;

     this.cdr.detectChanges();

   })

  }

  search(q:string){
    this.view='search';
    this.loading=true;
    this.data2service.searchArticles(q).subscribe(resp=>{
     
      this.searchResults = resp;
      this.loading=false;
        this.cdr.detectChanges();
    })
  }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'investing for catholics articles, ccatholic articles, catholic finances, investing catholics'});
    this.meta.addTag({name: 'description', content: 'Articles on investing, mutual funds, personal finance, tax options, retirement, tax planning, and financial planning for catholics.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});
  }

  onChangePage(pageOfItems: Array<any>) {
    // update current page of items
    this.pageOfItems = pageOfItems;
}

}
